if (!customElements.get('personalization-standard')) {
  customElements.define(
    'personalization-standard',
    class PersonalizationStandard extends HTMLElement {
      constructor() {
        super();

        this.onSubmitCapture = this.onSubmitCapture.bind(this);
      }

      connectedCallback() {
        this.form = this.closest('form');
        this.productForm = this.closest('product-form');
        this.modeInputs = Array.from(this.querySelectorAll('[data-standard-mode]'));
        this.colorPanel = this.querySelector('[data-standard-color-panel]');
        this.redirectPanel = this.querySelector('[data-standard-redirect-panel]');
        this.colorSelect = this.querySelector('[data-garn-select]');
        this.colorTrigger = this.querySelector('[data-garn-trigger]');
        this.error = this.querySelector('[data-standard-error]');

        this.modeInputs.forEach((input) => {
          input.addEventListener('change', () => this.applyMode());
        });

        this.colorSelect?.addEventListener('change', () => this.clearError());

        if (this.productForm) {
          this.productForm.addEventListener('submit', this.onSubmitCapture, true);
        } else {
          this.form?.addEventListener('submit', this.onSubmitCapture, true);
        }

        this.applyMode();
      }

      disconnectedCallback() {
        if (this.productForm) {
          this.productForm.removeEventListener('submit', this.onSubmitCapture, true);
        } else {
          this.form?.removeEventListener('submit', this.onSubmitCapture, true);
        }
      }

      get selectedMode() {
        return this.modeInputs.find((input) => input.checked)?.dataset.standardMode || 'default';
      }

      applyMode() {
        const mode = this.selectedMode;
        const showColor = mode === 'color';
        const showRedirect = mode === 'redirect';

        if (this.colorPanel) this.colorPanel.hidden = !showColor;
        if (this.redirectPanel) this.redirectPanel.hidden = !showRedirect;
        if (this.colorSelect) this.colorSelect.disabled = !showColor;

        if (!showColor) this.clearError();
      }

      onSubmitCapture(event) {
        if (this.form && event.target !== this.form) return;

        const mode = this.selectedMode;

        if (mode === 'redirect') {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.redirectPanel?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        if (mode !== 'color') return;

        if (!this.colorSelect?.value) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.showError();
          return;
        }

        this.colorSelect.disabled = false;
      }

      showError() {
        if (this.error) this.error.hidden = false;
        this.colorTrigger?.setAttribute('aria-invalid', 'true');
        this.colorTrigger?.focus();
      }

      clearError() {
        if (this.error) this.error.hidden = true;
        this.colorTrigger?.removeAttribute('aria-invalid');
      }
    }
  );
}